/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Achievement_LockedInputs */

const en_us2_progress_extra_achievement_locked = /** @type {(inputs: Progress_Extra_Achievement_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not yet`)
};

const pt_br2_progress_extra_achievement_locked = /** @type {(inputs: Progress_Extra_Achievement_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não`)
};

const es_419_progress_extra_achievement_locked = /** @type {(inputs: Progress_Extra_Achievement_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no`)
};

const pt_pt2_progress_extra_achievement_locked = /** @type {(inputs: Progress_Extra_Achievement_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ainda não`)
};

const fr_fr2_progress_extra_achievement_locked = /** @type {(inputs: Progress_Extra_Achievement_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas encore`)
};

const de_de2_progress_extra_achievement_locked = /** @type {(inputs: Progress_Extra_Achievement_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch nicht`)
};

const it_it2_progress_extra_achievement_locked = /** @type {(inputs: Progress_Extra_Achievement_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non ancora`)
};

/**
* | output |
* | --- |
* | "Not yet" |
*
* @param {Progress_Extra_Achievement_LockedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_achievement_locked = /** @type {((inputs?: Progress_Extra_Achievement_LockedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Achievement_LockedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_achievement_locked(inputs)
	if (locale === "es-419") return es_419_progress_extra_achievement_locked(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_achievement_locked(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_achievement_locked(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_achievement_locked(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_achievement_locked(inputs)
	return en_us2_progress_extra_achievement_locked(inputs)
});
export { progress_extra_achievement_locked as "progress-extra.achievement_locked" }